"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevenueRecognitionMethodEnum = exports.ProductModuleEnum = void 0;
var ProductModuleEnum;
(function (ProductModuleEnum) {
    ProductModuleEnum[ProductModuleEnum["CLUB_TEAMS"] = 1] = "CLUB_TEAMS";
    ProductModuleEnum[ProductModuleEnum["COMMERCE"] = 2] = "COMMERCE";
    ProductModuleEnum[ProductModuleEnum["LEAGUES"] = 3] = "LEAGUES";
    ProductModuleEnum[ProductModuleEnum["MEMBERSHIPS"] = 4] = "MEMBERSHIPS";
    ProductModuleEnum[ProductModuleEnum["PROGRAMS"] = 5] = "PROGRAMS";
    ProductModuleEnum[ProductModuleEnum["RESERVATIONS"] = 6] = "RESERVATIONS";
})(ProductModuleEnum = exports.ProductModuleEnum || (exports.ProductModuleEnum = {}));
var RevenueRecognitionMethodEnum;
(function (RevenueRecognitionMethodEnum) {
    RevenueRecognitionMethodEnum["BY_EVENT"] = "by_event";
    RevenueRecognitionMethodEnum["EVENLY"] = "evenly";
    RevenueRecognitionMethodEnum["UPFRONT"] = "upfront";
    RevenueRecognitionMethodEnum["MILESTONES"] = "milestones";
})(RevenueRecognitionMethodEnum = exports.RevenueRecognitionMethodEnum || (exports.RevenueRecognitionMethodEnum = {}));
//# sourceMappingURL=accounting.enums.js.map